/* eslint-disable compat/compat */

export var runWhenIdle = function runWhenIdle(callback) {
  return window.requestIdleCallback ? window.requestIdleCallback(callback, {
    timeout: 5000
  }) : window.requestAnimationFrame(callback);
};